// Notice Progress — the top-nav Reports page's Notice Tracking tab, moved to Live Reporting (step 8 part 6). A CARD
// definition: it renders its own component (KPI cards, progress bar, the By Assessor table and its drill-down into the
// parcels) instead of the generic ReportView, because the drill-down and opening a parcel have no ReportView equivalent.
import NoticeProgress from '../cards/NoticeProgress';

const noticeProgress = {
  id: 'notice_progress',
  title: 'Notice Progress',
  description: 'Notices received and still waiting, by assessor / county, with expected-by dates and days late. Click a count to see the parcels.',
  component: NoticeProgress,
};

export default noticeProgress;
